import React from 'react'
import {
  H3,
  Overline,
  Subheading,
  Button,
  Separator,
  Image,
  Grid,
  Cell,
  Bleed,
  LayoutBand,
  usePageWidth,
} from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import helpAndLearningImg from './images/help-and-learning-image.webp'
import helpAndLearningImgMobile from './images/help-and-learning-image-mobile.png'

export default function HelpAndLearning() {
  const { t } = useTranslation()
  const atPageWidth = usePageWidth()
  return (
    <LayoutBand marginX="xl">
      <Bleed start>
        <Grid>
          <Bleed all columns={atPageWidth({ default: 12, md: 6, xl: 6 })}>
            {/** Lets look at this image. How do we want it to look at xxl breakpoints. We can keep bleeding it over but eventually we don't want it to go more left. */}
            <Image
              src={atPageWidth({ default: helpAndLearningImgMobile, md: helpAndLearningImg })}
              alt={t(
                'nlihp.united-states.help-and-learning.image-alt',
                'Help desk woman looking at a screen and smiling'
              )}
            />
          </Bleed>
          <Cell columns={atPageWidth({ default: 12, md: 1, xl: 1 })}>
            <div />
          </Cell>
          {atPageWidth({ default: false, md: true }) && (
            <Cell columns={atPageWidth({ default: 12, md: 5, xl: 4 })} alignY="middle">
              {atPageWidth({ default: false, md: true }) && <Separator size="md" />}
              <H3 size="H5">
                <Overline>{t('nlihp.united-states.help-and-learning.overline', 'Help and Learning')}</Overline>
                {t('nlihp.united-states.help-and-learning.heading', 'Find a guide, in person or online')}
                <Subheading>
                  {t(
                    'nlihp.united-states.help-and-learning.subheading',
                    'We provide free guidance and resources to help you make more family history discoveries. Search a location near you, or schedule an online consultation to begin your journey.'
                  )}
                </Subheading>
              </H3>
              <Separator size="xs" />
              <Button
                emphasis="medium"
                external
                to="/help/helpcenter/one-on-one"
                color="gray"
                linkName="See the options"
                target="_blank"
              >
                {t('nlihp.united-states.help-and-learning.see-options', 'See the options')}
              </Button>
              <Separator size="md" />
            </Cell>
          )}
        </Grid>
      </Bleed>
      {atPageWidth({ default: true, md: false }) && (
        <div>
          <H3 size="H5">
            <Overline>{t('nlihp.united-states.help-and-learning.overline', 'Help and Learning')}</Overline>
            {t('nlihp.united-states.help-and-learning.heading', 'Find a guide, in person or online')}
            <Subheading>
              {t(
                'nlihp.united-states.help-and-learning.subheading',
                'We provide free guidance and resources to help you make more family history discoveries. Search a location near you, or schedule an online consultation to begin your journey.'
              )}
            </Subheading>
          </H3>
          <Separator size="xs" />
          <Button
            emphasis="medium"
            external
            to="/help/helpcenter/one-on-one"
            linkName="See the options"
            target="_blank"
          >
            {t('nlihp.united-states.help-and-learning.see-options', 'See the options')}
          </Button>
          <Separator size="md" />
        </div>
      )}
    </LayoutBand>
  )
}
